import React from "react";
import CheckboxField from "../../Common/Form/CheckboxField";
import { LEGAL_PATHS } from "./legalRules";

const DocLink = ({ to, children }) => (
  <a
    href={to}
    target="_blank"
    rel="noopener noreferrer"
    className="text-brand underline hover:text-brand-hover"
  >
    {children}
  </a>
);

/**
 * Sign-up legal block (hand-off 4.2): contract language (French by default),
 * the English choice when English is chosen, the required acceptance with both
 * documents linked, the email/SMS notice, and optional news and offers.
 */
const LegalAgreement = ({ value, onChange, errors = {} }) => {
  const set = (field, fieldValue) =>
    onChange({ ...value, [field]: fieldValue });
  const english = value.contract_language === "en";

  return (
    <div className="space-y-3" data-testid="legal-agreement">
      <fieldset>
        <legend className="text-sm font-medium text-ui-text mb-1">
          Langue du contrat / Contract language:
        </legend>
        <div className="flex items-center gap-6">
          {[
            ["fr", "Français"],
            ["en", "English"],
          ].map(([code, label]) => (
            <label
              key={code}
              className="flex items-center gap-2 text-sm text-ui-text cursor-pointer"
            >
              <input
                type="radio"
                name="contract_language"
                value={code}
                checked={value.contract_language === code}
                onChange={() =>
                  onChange({
                    ...value,
                    contract_language: code,
                    english_choice_confirmed:
                      code === "en" ? value.english_choice_confirmed : false,
                  })
                }
                className="h-4 w-4 text-brand focus:ring-brand border-ui-border"
              />
              {label}
            </label>
          ))}
        </div>
      </fieldset>

      {english && (
        <div data-field="english_choice_confirmed">
          <CheckboxField
            label="Après avoir reçu la version française, je choisis expressément d'être lié(e) par la version anglaise. / Having received the French version, I expressly choose to be bound by the English version."
            checked={value.english_choice_confirmed}
            onChange={(e) => set("english_choice_confirmed", e.target.checked)}
            error={errors.english_choice_confirmed}
            required
          />
        </div>
      )}

      <div data-field="accept_terms">
        <CheckboxField
          label={
            <>
              J'ai lu et j'accepte les{" "}
              <DocLink to={LEGAL_PATHS.terms.fr}>
                Conditions d'utilisation
              </DocLink>{" "}
              et la{" "}
              <DocLink to={LEGAL_PATHS.privacy.fr}>
                Politique de confidentialité
              </DocLink>{" "}
              de HAJEX Bolt, y compris ma responsabilité pour tous les frais de
              transport, droits, taxes et ajustements des envois créés depuis
              mon compte. / I have read and accept the HAJEX Bolt{" "}
              <DocLink to={LEGAL_PATHS.terms.en}>Terms of Service</DocLink> and{" "}
              <DocLink to={LEGAL_PATHS.privacy.en}>Privacy Policy</DocLink>,
              including my responsibility for all carrier charges, duties, taxes
              and adjustments on shipments created from my account.
            </>
          }
          checked={value.accept_terms}
          onChange={(e) => set("accept_terms", e.target.checked)}
          error={errors.accept_terms}
          required
        />
      </div>

      <p className="text-sm text-ui-text-muted m-0">
        Nous vous enverrons des courriels et SMS sur vos soumissions et vos
        envois. / We will send you emails and SMS about your quotes and
        shipments.
      </p>

      <CheckboxField
        label="Je souhaite recevoir les nouvelles et offres de HAJEX Bolt (désabonnement en tout temps). / I want to receive HAJEX Bolt news and offers (unsubscribe anytime)."
        checked={value.marketing_consent}
        onChange={(e) => set("marketing_consent", e.target.checked)}
      />
    </div>
  );
};

export default LegalAgreement;
